export enum AgreementStatus {
  Initializing = 1,
  Waiting,
  Agreed,
  Completed,
  NotApplicable,
}

export enum Agreements {
  TermsAndConditions = 'TERMS_AND_CONDITIONS',
  MemberFinancialPolicy = 'MEMBER_FINANCIAL_POLICY',
  NpInformedConsent = 'NEURO_PSYCH_EVAL_INFORMED_CONSENT',
  NpFinancialPolicyPrice = 'NEURO_PSYCH_EVAL_FINANCIAL_POLICY_AND_PRICING',
  HealthInfo = 'GINA',
  TeenConsent = 'TEEN_CONSENT',
  NpTeenConsent = 'NP_TEEN_CONSENT',
  ConsentToCare = 'CONSENT_TO_TREAT_MINOR',
}

export const isAgreementStatusResolved = (s: AgreementStatus) =>
  s === AgreementStatus.Agreed || s === AgreementStatus.Completed || s === AgreementStatus.NotApplicable;

export const isAgreementStatusRequired = (s: AgreementStatus) =>
  s === AgreementStatus.Waiting || s === AgreementStatus.Agreed || s === AgreementStatus.Completed;
